export default __webpack_public_path__ + "static/media/default-preview.0f11c297.svg";